import { ServerApiMapper } from '~commonInfra/utils/ServerModelHelper';

import { IListFetcher } from '../../httpClient/fetchers/IListFetcher';
import { WebClientListResourceFetcher } from '../../httpClient/fetchers/resourceFetchers/WebClientListResourceFetcher';
import { IListResource } from '../../httpClient/resources/Resource';
import { ResourceQuery } from '../../httpClient/resources/ResourceQuery';
import { ITableInfo } from '../models/ITableInfo';
import { GetTablesRequest } from '../serverApi/requests/databases/GetTablesRequest';


class TablesWithCrassResource implements IListResource<ITableInfo> {

  private listFetcher: IListFetcher<ITableInfo> = new WebClientListResourceFetcher(GetTablesRequest, ServerApiMapper.tablesUsingCrass);

  public all(): ResourceQuery<ITableInfo> {
    return new ResourceQuery(this.listFetcher);
  }
}

export const TablesWithCrass = new TablesWithCrassResource();
export type TablesWithCrass = typeof TablesWithCrass;
